import React from 'react'
import {useHistory} from 'react-router-dom'

const EditPasswordCom = () => {
  const history = useHistory()
  return (
    <>
      <div className="user-info-wrap">
        <div className="second-title" style={{color: '#262626'}}>
          修改密码
        </div>
        <div style={{color: '#8c8c8c', marginTop: 12, marginBottom: 12}}>请选择一种验证方式</div>
        <div className="user-info-password-box-outer">
          <div
            className="user-info-password-box"
            onClick={() => {
              history.push('/user/old_password_form')
            }}
          >
            原始密码验证
          </div>
          <div style={{color: '#8c8c8c', marginLeft: 20, marginRight: 20, marginTop: 30}}>或者</div>
          <div
            className="user-info-password-box"
            onClick={() => {
              history.push('/user/phone_form')
            }}
          >
            手机验证码验证
          </div>
        </div>
        <div className="small" style={{color: '#bfbfbf', marginTop: 20}}>
          如果没有绑定手机号且忘记密码，请联系管理员重置密码
        </div>
      </div>
    </>
  )
}

export default EditPasswordCom
